import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CustomersPage, ModalSetUserInfoPage } from './customers';
import { CalendarModule } from 'ion2-calendar';
import { RestProvider } from '../../providers/rest/rest';
import {NgxPaginationModule} from 'ngx-pagination';

@NgModule({
  declarations: [
    CustomersPage,
    ModalSetUserInfoPage,
  ],
  imports: [
    IonicPageModule.forChild(CustomersPage),
    CalendarModule,
    NgxPaginationModule,
  ],

  entryComponents: [
    ModalSetUserInfoPage,
  ],
  providers: [
    RestProvider,
  ]
})
export class CustomersPageModule {}



// WEBPACK FOOTER //
// ./src/pages/customers/customers.module.ts